import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.scss";

import headerImg from "../../assets/header-img-3-compressed.png";
// import headerBackground from "../../assets/header-background.png";
import Navbar2026 from "../Navbar2026/Navbar";
import { useTranslation } from "react-i18next";
import playIcon from "../../assets/icon-play-white.svg";
import headerIcons from "../../assets/header-icons.png";

const Timer = () => {
    const eventDate = new Date("2026-06-05T00:00:00"); // Set your event date here
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    useEffect(() => {
        const timer = setInterval(() => {
            const now = new Date();
            const distance = eventDate - now;

            if (distance <= 0) {
                clearInterval(timer);
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            setTimeLeft({ days, hours, minutes, seconds });
        }, 1000);

        return () => clearInterval(timer); // Cleanup the interval on component unmount
    }, [eventDate]);

    return (
        <div className={`timer-container lang-${currentLang}`}>
            <div className="timer-content">
                {/* <div className={`text lang-${currentLang}`}>{t("untilNextYear")}</div> */}
                <div className="timer">
                    <div className="time-block">
                        <span>{timeLeft.days}</span>
                        <p>{t("days")}</p>
                    </div>
                    <div className="time-block">
                        <span>{timeLeft.hours}</span>
                        <p>{t("hours")}</p>
                    </div>
                    <div className="time-block">
                        <span>{timeLeft.minutes}</span>
                        <p>{t("minutes")}</p>
                    </div>
                    <div className="time-block">
                        <span>{timeLeft.seconds}</span>
                        <p>{t("seconds")}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

function Header() {
    const { t } = useTranslation();

    return (
        <header id="home" className="header-container">
            <Navbar2026 />

            <div className="img-wrapper">
                <img src={headerImg} alt="" className="header-img" />

                <div className="content-wrapper">


                    <div className="content">
                        <div className="actions-container">
                            <h1>KUKOLJ TEAM <br />
                                MASTERCLASS</h1>
                            <div className="year-card">2026</div>

                            <div className="buttons-container">

                                {/* <Link to="/contact" className="contact-link"><button className="btn btn-sign-up">{t("signUp")}</button></Link> */}
                                <a
                                    className="btn btn-recap"
                                    href="https://www.instagram.com/reel/DS7pYVOCr1V/?igsh=MW44eHRqajBlNTdxZQ=="
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={playIcon} alt="" />
                                    {t("recap2025")}
                                </a>

                            </div>
                            
                            {/* <p className="participation-price">
                                {t("participationPrice")}{" "}
                                <span className="participation-price__amount">
                                    {t("participationPriceAmount")}
                                </span>
                            </p> */}

                            <div className="header-icons"><img src={headerIcons} alt="" />{t("participantsStat2025")}</div>

                        </div>
                    </div>


                    <Timer />
                </div>
            </div>

        </header>
    );
}

export default Header;
